<template>
    <div class="DisplayLargeScreen">
        <div class="Head flex-align-center">
            <div class="Head_title">{{ $route.query.schoolName }}</div>
        </div>
        <div class="Center">
            <div class="LeftLayout">
                <div class="AssessmentResults Positioning">
                    <div class="Title text">古诗测评各年级成绩分布情况</div>
                    <div class="GradeQuadrantDiagram flex-align-center" v-for="(item, index) in gradeQuadrantDiagramData"
                        :key="index">
                        <img :src="item.img" alt="" @click="Amplify(item.img)">
                        <span>{{ item.className }}</span>
                    </div>
                </div>
                <div class="ApplicationTime Positioning">
                    <div class="Title text">本校应用时间分布情况</div>
                    <div class="ApplicationTimeDiagram Spacing" id="temporal_distribution"></div>
                </div>
            </div>
            <div class="CenterLayout">
                <div class="TrendChart flex-align-center  Positioning">
                    <div class="Title text">2025-2026学年班级变化趋势象限图</div>
                    <div class="TrendChartDiagram flex-align-center Spacing">
                        <div class="PreviousPage Switch" @click="PreviousPage"></div>
                        <el-carousel ref="myCarousel" indicator-position="none" arrow="never" :autoplay="false">
                            <el-carousel-item v-for="(item, index) in carousel_list" :key="index">
                                <div class="carousel_tem flex-align-around">
                                    <div class="carousel_Class flex-column-center">
                                        <img :src="item.img1" @click="Amplify(item.img1)" alt="">
                                        <div class="Class_name wes">前测 {{ item.title }}</div>
                                    </div>
                                    <div class="carousel_Class flex-column-center">
                                        <img :src="item.img2" @click="Amplify(item.img2)" alt="">
                                        <div class="Class_name wes">古诗 {{ item.title }}</div>
                                    </div>

                                </div>
                            </el-carousel-item>
                        </el-carousel>
                        <div class="NextPage Switch" @click="NextPage"></div>
                    </div>
                </div>
                <div class="ScoreDistribution flex-align-center Positioning">
                    <div class="Title text">古诗测评成绩分布情况</div>
                    <div class="ScoreDistributionDiagram Spacing flex-align-center">
                        <img src="../../assets/datascreen/DisplayLargeScreen/a1.png" alt="">
                    </div>
                </div>
                <div class="HistoricalEvaluation flex-align-center Positioning">
                    <div class="Title text">本校历次测评成绩分布情况</div>
                    <div class="HistoricalEvaluationDiagram Spacing flex-align-center">
                        <img src="../../assets/datascreen/DisplayLargeScreen/b1.png" alt="">
                    </div>
                </div>
            </div>
            <div class="RightLayout">
                <div class="StudentTrends flex-align-center Positioning">
                    <div class="Title text">2024-2025学年学生变化趋势象限图</div>
                    <div class="StudentTrendsDiagram Spacing flex-column-center">
                        <div class="TrendContent flex-align-center">
                            <img :src="Studentlist[currentPageIndex].img" alt=""
                                @click="Amplify(Studentlist[currentPageIndex].img)">
                            <span>{{ Studentlist[currentPageIndex].name }}</span>
                        </div>
                        <div class="Paging flex-align-center">
                            {{ currentPageIndex }}
                            <el-pagination small background layout="total, prev, pager, next" :page-size="1" :total="12"
                                :current-page.sync="currentPage" @current-change="handlePageChange">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <div class="WorksOfExcellence flex-align-center Positioning">
                    <div class="Title text">优秀学生作品案例</div>
                    <div class="WorksOfExcellenceDiagram Spacing">
                        <vue-seamless-scroll :data="listData" :class-option="classOption" class="warp">
                            <ul class="item">
                                <li v-for="(item, index) in listData" :key="index">
                                    <div class="word flex-column-center">
                                        <div class="word-text">{{ item.name }}</div>
                                        <div class="words flex-align-center">
                                            <img :src="item.file_path" alt="" @click="Amplify(item.file_path)">
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </vue-seamless-scroll>
                    </div>

                </div>
            </div>
        </div>
        <div class="appraisalbox">
            <el-dialog :visible.sync="centerDialogVisible" :modal-append-to-body="false" :append-to-body="false"
                :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" center>
                <div class="AmplifyUrlbox">
                    <img :src="AmplifyUrl" alt="">
                </div>
                <img class="close" src="../../assets/datascreen/close.png" @click="close" />
            </el-dialog>
        </div>
    </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
import axios from 'axios';
export default {
    //import引入组件才能使用
    components: { vueSeamlessScroll },
    props: {},
    data() {
        return {
            gradeQuadrantDiagramData: [
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/class1.png'),
                    className: '一年级'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/class2.png'),
                    className: '二年级'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/class3.png'),
                    className: '三年级'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/class4.png'),
                    className: '四年级'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/class5.png'),
                    className: '五年级'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/class6.png'),
                    className: '六年级'
                },
            ],
            school_Id: null,
            termKey: null,
            temporal_distribution_Show: '',
            currentPageIndex: 0,
            currentPage: 1,
            carousel_list: [
                {
                    img1: require('../../assets/datascreen/DisplayLargeScreen/s1.png'),
                    img2: require('../../assets/datascreen/DisplayLargeScreen/s2.png'),
                    title: '一年级1班'
                },
                {
                    img1: require('../../assets/datascreen/DisplayLargeScreen/s3.png'),
                    img2: require('../../assets/datascreen/DisplayLargeScreen/s4.png'),
                    title: '五年级11班'
                },
                {
                    img1: require('../../assets/datascreen/DisplayLargeScreen/s5.png'),
                    img2: require('../../assets/datascreen/DisplayLargeScreen/s6.png'),
                    title: '四年级8班'
                },
                {
                    img1: require('../../assets/datascreen/DisplayLargeScreen/s7.png'),
                    img2: require('../../assets/datascreen/DisplayLargeScreen/s8.png'),
                    title: '三年级6班'
                },
                {
                    img1: require('../../assets/datascreen/DisplayLargeScreen/s9.png'),
                    img2: require('../../assets/datascreen/DisplayLargeScreen/s10.png'),
                    title: '六年级5班'
                },
                {
                    img1: require('../../assets/datascreen/DisplayLargeScreen/s11.png'),
                    img2: require('../../assets/datascreen/DisplayLargeScreen/s12.png'),
                    title: '二年级11班'
                },

            ],
            Studentlist: [
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words1.png'),
                    name: '陈开绮'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words2.png'),
                    name: '薛筱霏'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words3.png'),
                    name: '沈楚峤'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words4.png'),
                    name: '冯雨佳'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words5.png'),
                    name: '邹思漫'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words6.png'),
                    name: '娄梓昱'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words7.png'),
                    name: '王天琳'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words8.png'),
                    name: '郑娇杨'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words9.png'),
                    name: '夏闻泽'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words10.png'),
                    name: '尹文'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words11.png'),
                    name: '徐羽萌'
                },
                {
                    img: require('../../assets/datascreen/DisplayLargeScreen/words12.png'),
                    name: '高裕森'
                },


            ],
            listData: [],
            classOption: {
                step: 1
            },
            AmplifyUrl: null,
            centerDialogVisible: false,
            autoPlayInterval: null, // 新增定时器变量
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        PreviousPage() {
            this.$refs.myCarousel.prev();
        },
        NextPage() {
            this.$refs.myCarousel.next();
        },
        //本校上课时间分布
        async getschoolTimeDistribution() {
            let that = this;
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: this.$route.query.date,
            };
            let resData = await this.$Api.DataScreen.getschoolTimeDistribution(data);
            //判断空数据
            let judge = (() => {
                for (let key in resData.data) {
                    if (Array.isArray(resData.data[key])) {
                        if (!resData.data[key].every(item => item === 0)) {
                            return false;
                        }
                    } else {
                        console.error(`Property ${key} is not an array`);
                        return false;
                    }
                }
                return true;
            })();
            this.temporal_distribution_Show = judge;
            if (this.temporal_distribution_Show) return;
            this.$nextTick(() => {
                that.temporal_distribution(resData.data)
            });
        },
        //应用时间分布
        temporal_distribution(value) {
            this.$echarts.init(document.getElementById("temporal_distribution")).dispose();
            let that = this;
            let myChart = this.$echarts.init(document.getElementById("temporal_distribution"));
            myChart.setOption({
                color: ['#8e4ebd', '#6bb1d8', '#2eae9c', '#66a85b', '#c55c94', '#ddb742',],
                tooltip: {
                    trigger: 'axis',
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                    },
                },
                legend: {
                    show: true,
                    icon: 'rect',
                    itemWidth: this.graphicRatio(20),
                    top: '4%',
                    itemHeight: this.graphicRatio(2),
                    textStyle: {
                        color: '#fff',
                        fontSize: this.graphicRatio(12),
                    }
                },
                grid: {
                    top: '18%',
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        color: '#fff',
                        fontSize: this.graphicRatio(12),
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#143c6d',
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'solid',
                            color: "#143c6d"
                        }
                    },

                    // boundaryGap: false,
                    data: ['0时', '1时', '2时', '3时', '4时', '5时', '6时', '7时', '8时', '9时', '10时', '11时', '12时', '13时', '14时', '15时', '16时', '17时', '18时', '19时', '20时', '21时', '22时', '23时']
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        color: '#fff',
                        fontSize: this.graphicRatio(12),
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'solid',
                            color: "#143c6d"
                        }
                    },

                },
                series: [
                    {
                        name: '一年级',
                        type: 'line',
                        showSymbol: false,
                        lineStyle: {
                            type: 'dashed',
                            width: this.graphicRatio(1),
                        },
                        data: value[1]
                    },
                    {
                        name: '二年级',
                        type: 'line',
                        showSymbol: false,
                        lineStyle: {
                            type: 'dashed',
                            width: this.graphicRatio(1),
                        },
                        data: value[2]
                    },
                    {
                        name: '三年级',
                        type: 'line',
                        showSymbol: false,
                        lineStyle: {
                            type: 'solid',
                            width: this.graphicRatio(1),
                        },
                        data: value[3]
                    },
                    {
                        name: '四年级',
                        type: 'line',
                        showSymbol: false,
                        lineStyle: {
                            type: 'dashed',
                            width: this.graphicRatio(1),
                        },
                        data: value[4]
                    },
                    {
                        name: '五年级',
                        type: 'line',
                        showSymbol: false,
                        lineStyle: {
                            type: 'dashed',
                            width: this.graphicRatio(1),
                        },
                        data: value[5]
                    },
                    {
                        name: '六年级',
                        type: 'line',
                        showSymbol: false,
                        lineStyle: {
                            type: 'solid',
                            width: this.graphicRatio(1),
                        },
                        data: value[6]
                    }
                ]
            });
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        // 分页页码改变时触发
        handlePageChange(currentPage) {
            console.log('当前页:', currentPage);
            this.stopAutoPlay(); // 停止自动播放防止冲突
            this.currentPage = currentPage;
            this.currentPageIndex = currentPage - 1;
            this.startAutoPlay();
        },
        Amplify(url) {
            this.AmplifyUrl = url;
            this.centerDialogVisible = true;
        },
        close() {
            this.centerDialogVisible = false;
        },
        getwordList() {
            axios({
                url: 'https://admin.cnuzi.com/prod-api/open/big-screen/work-list',
                method: 'get',
            }).then(resData => {
                console.log('获取token成功', resData);
                this.listData = resData.data;
            }).catch(err => {
                console.log('获取token失败', err);
            });

        },
        startAutoPlay() {
            this.autoPlayInterval = setInterval(() => {
                this.currentPageIndex = (this.currentPageIndex + 1) % this.Studentlist.length;
                this.handlePageChange(this.currentPageIndex + 1); // 因为 el-pagination 的 current-change 返回的是从1开始的页码
            }, 2000);
        },
        stopAutoPlay() {
            if (this.autoPlayInterval) {
                clearInterval(this.autoPlayInterval);
                this.autoPlayInterval = null;
            }
        },
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.getschoolTimeDistribution();
        this.getwordList();
        this.startAutoPlay(); // 启动自动播放
        // console.log(this.$route.query.schoolId);


    },
    beforeDestroy() {
        this.stopAutoPlay();
    }
}
</script>
<style lang="less" scoped>
@import "./less/DisplayLargeScreen.less";
</style>